import {
    useMemo,
    type FC
} from "react";
import {
    View
} from "react-native";
import type ITraceProps from "./type";
import type {
    TraceContextType
} from "./type";
import stylesheet from "./stylesheet";
import TraceCollapsible from "./components/collapsible";
import TraceContent from "./components/content";
import TraceLine from "./components/line";
import TracePlan from "./components/plan";
import TraceReasoning from "./components/reasoning";
import TraceSources from "./components/sources";
import TraceToolCall from "./components/toolCall";
import TraceTrigger from "./components/trigger";
import {
    TraceContext
} from "./context";

const Trace: FC<ITraceProps> = ({
    customLocalize,
    customTheme,
    children,
    style,
    ...props
}) => {
    const context: TraceContextType = useMemo(() => ({
        customLocalize,
        customTheme
    }), [
        customLocalize,
        customTheme
    ]);

    return <TraceContext.Provider
        value={context}
    >
        <View
            {...props}
            style={[
                style,
                stylesheet.container
            ]}
        >
            {children}
        </View>
    </TraceContext.Provider>;
};
export default Object.assign(Trace, {
    Collapsible: TraceCollapsible,
    Reasoning: TraceReasoning,
    ToolCall: TraceToolCall,
    Content: TraceContent,
    Sources: TraceSources,
    Trigger: TraceTrigger,
    Plan: TracePlan,
    Line: TraceLine
});
